import { GET_API_TOKEN, API_BASE_URL } from '../../constants/apiConstants'
import axios from '../../helpers/Axios'
const baseUrl = API_BASE_URL

export const getPatientsData = async (): Promise<object> => {
  return axios({
    method: 'get',
    baseURL: baseUrl,
    url: `/api/rpmweb/admissions`,
    headers: {
      Authorization: `Bearer ${GET_API_TOKEN()}`,
    },
  })
}
